import { useTranslations } from '@vocab/react';
import {
  Box,
  Button,
  Column,
  Columns,
  IconArrow,
  Inline,
} from 'braid-design-system';
import React, { type FunctionComponent } from 'react';

import { BackButton } from 'src/app/v1/views/shared/BackButton';
import { PreviewButton } from 'src/app/v1/views/shared/PreviewButton';
import type { ValidationResultType } from 'src/types/validation';

import translations from './.vocab';
import { SaveDraftButton } from './components/SaveDraftButton';

interface Props {
  className?: string;
  isLoading?: boolean;
  showBackButton?: boolean;
  onBackButtonClicked?: () => void;
  showPreviewButton?: boolean;
  handleSaveDraftFailed: () => void;
  handleValidation: () => Promise<ValidationResultType> | ValidationResultType;
}

export const PageButtons: FunctionComponent<Props> = ({
  className = null,
  isLoading = false,
  showBackButton = false,
  onBackButtonClicked,
  showPreviewButton = false,
  handleSaveDraftFailed,
  handleValidation,
}) => {
  const { t } = useTranslations(translations);

  return (
    <Box paddingX={['gutter', 'none']} className={className}>
      <Columns collapseBelow="tablet" space="xsmall">
        <Column width="content">
          <Inline collapseBelow="tablet" space="xsmall">
            {showBackButton && onBackButtonClicked && (
              <BackButton onClick={onBackButtonClicked}>
                {t('page-buttons-back-label')}
              </BackButton>
            )}
          </Inline>
        </Column>
        <Column>
          <Inline space="xsmall" collapseBelow="tablet" align="right">
            <SaveDraftButton
              handleSaveDraftFailed={handleSaveDraftFailed}
              handleValidation={handleValidation}
            />
            {showPreviewButton && <PreviewButton />}
            <Button
              type="submit"
              icon={<IconArrow direction="right" />}
              iconPosition="trailing"
              id="next-page-button"
              loading={isLoading}
              tone="formAccent"
              variant="solid"
            >
              {t('page-buttons-continue-label')}
            </Button>
          </Inline>
        </Column>
      </Columns>
    </Box>
  );
};
